export const blockIconsTransportationSubwayNew = (
	<span className='material-symbols-outlined'>subway</span>
);
